
import * as React from "react";
import { IActiveOrders } from "../../../interfaces/IOrder";
import ModifyOfferDialog from "../offer/ModifyOfferDialog";
import ModifyHour from "./ModifyHour";
import $ from "jquery";

interface IOrderItemProps {
    item                             : any
}


interface IOrderItemState {
    openModifyModal: boolean
    order: any
}

export default class OrderItem extends React.Component<IOrderItemProps, IOrderItemState>{

    constructor(props:IOrderItemProps){
        super(props);
        this.state = {
            openModifyModal: false,
            order: this.props.item
        }
    }



    private changeHours(order){
        this.setState({
            openModifyModal: false,
            order: order
        }, () =>{
            $('#modify_order_modal').modal('toggle');
            if ( document.querySelector('.modal-backdrop') !== null ) {
                $('.modal-backdrop').remove();
            }
        });
    }



    render() {
        let item = this.state.order;

        if(this.state.openModifyModal) {
            setTimeout(() => {
                if ( document.querySelector('#modify_order_modal') !== null ) {
                    $('#modify_order_modal').modal({show:true});
                }

            }, 200);
        }

        return (
            <>
                <div className = "order-item">
                    <p className = "offer-type">{item.offer.offerType.name}</p>
                    <p className = "order-hours">{item.hours} hour</p>
                    <hr/>
                    <div className = "price-row">
                        {
                            ( item.status.key != 'completed' && item.status.key != 'cancelled' && item.status.key != 'processing' ) &&
                            <div className = "modify-btn">
                                <button className = "purple_btn" onClick={() => this.setState({openModifyModal: true})}>Modify</button>
                            </div>
                        }

                        <p className = "price">{item.price} {item.currency}</p>
                    </div>
                    <div className = "status-box">
                        <p className = "status-title">Status:</p>
                        <p className = "status-name">{item.status.name}</p>
                    </div>
                </div>

                {
                    this.state.openModifyModal &&
                    <div role="dialog" className="modal fade" id="modify_order_modal">
                        <div className="modal-dialog modal-md" role="document">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <ModifyHour order={item} closed={(order) => this.changeHours(order)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </>
        );
    }
}
